// Vendors
import { apiUtils } from '@openbank/cf-ui-architecture-core';
// Constants
import { EXTEND_SESSION_SERVICE_CONFIGURATION } from './constants/extend-session.service.constants';

const extendCustomerSessionLifeService = async (): Promise<[Record<string, any>, Response]> =>
  apiUtils.post(EXTEND_SESSION_SERVICE_CONFIGURATION);

export { extendCustomerSessionLifeService };
